export default "__VITE_ASSET__CqbVTteQ__"